import { render } from "./channelFinancial.vue?vue&type=template&id=c84eb334&scoped=true"
import script from "./channelFinancial.vue?vue&type=script&lang=js"
export * from "./channelFinancial.vue?vue&type=script&lang=js"

import "./channelFinancial.vue?vue&type=style&index=0&id=c84eb334&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84eb334"]])

export default __exports__